export default "__VITE_ASSET__DyjZeks6__"